import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import "./BlogPage.css";

function BlogPage() {
  usePageTitle("Blog", "Explore as últimas novidades, tutoriais e guias sobre o universo Discord e automação no blog da BotGate.");

  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Buscar posts
        const postsRes = await fetch(
          `${BACKEND_URL}/api/blog/posts${
            selectedCategory !== "Todos"
              ? `?category=${selectedCategory
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .replace(/[^a-z0-9]+/g, "-")}`
              : ""
          }`,
        );

        const postsData = await postsRes.json();
        setPosts(postsData.data || []);

        // Buscar categorias e posts recentes apenas uma vez
        if (categories.length === 0) {
          const catRes = await fetch(`${BACKEND_URL}/api/blog/categories`);
          const catData = await catRes.json();
          setCategories(catData.data || []);

          const recentRes = await fetch(`${BACKEND_URL}/api/blog/posts?limit=3`);

          const recentData = await recentRes.json();
          setRecentPosts(recentData.data || []);
        }
      } catch (error) {
        console.error("Erro ao carregar blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedCategory, categories.length, BACKEND_URL]);

  return (
    <div className="blog-page">
      <div className="blog-hero">
        <div className="blog-hero-content">
          <h1>Blog</h1>
          <p>Explore as últimas novidades, tutoriais e guias sobre o universo Discord e automação.</p>
        </div>
      </div>

      <div className="blog-container">
        <aside className="blog-sidebar">
          <div className="sidebar-section">
            <h3>Categorias</h3>
            <ul className="sidebar-categories">
              <li className={selectedCategory === "Todos" ? "active" : ""} onClick={() => setSelectedCategory("Todos")}>
                <span>Todos</span>
                <span className="category-count">{posts.length}</span>
              </li>
              {categories.map((cat) => (
                <li key={cat.id} className={selectedCategory === cat.name ? "active" : ""} onClick={() => setSelectedCategory(cat.name)}>
                  <span>{cat.name}</span>
                  <span className="category-count">{cat.post_count}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="sidebar-section">
            <h3>Posts Recentes</h3>
            <ul className="sidebar-recent">
              {recentPosts.map((post) => (
                <li key={post.id}>
                  <Link to={`/blog/${post.slug}`}>
                    <span className="recent-title">{post.title}</span>
                    <span className="recent-date">{new Date(post.published_at).toLocaleString("pt-BR")}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <main className="blog-main">
          {loading ? (
            <div className="blog-posts-list">
              <p style={{ color: "rgba(255,255,255,0.4)" }}>Carregando artigos...</p>
            </div>
          ) : (
            <div className="blog-posts-list">
              {posts.map((post) => (
                <Link key={post.id} to={`/blog/${post.slug}`} className="blog-post-item">
                  <header className="post-item-header">
                    <span className="post-item-category">{post.category_name}</span>
                    <span className="post-item-date">{new Date(post.published_at).toLocaleString("pt-BR")}</span>
                  </header>
                  <h2 className="post-item-title">{post.title}</h2>
                  <p className="post-item-description">{post.description}</p>
                  <footer className="post-item-footer">
                    <div className="post-item-meta">
                      <span className="post-item-author">Por {post.author_username}</span>
                      <span className="post-item-separator">•</span>
                      <span>{post.read_time} de leitura</span>
                    </div>
                    <span className="post-item-arrow">→</span>
                  </footer>
                </Link>
              ))}

              {posts.length === 0 && <div className="blog-empty">Nenhum artigo encontrado nesta categoria.</div>}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default BlogPage;
